var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_Actions_ic-actions-paste",
    "data-name": "Icons / Actions / ic-actions-paste",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 19,
    height: 19,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-actions-paste",
    transform: "translate(3.025 2.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 9.5,
    height: 9.5,
    rx: 2,
    transform: "translate(5.496 4.75)",
    fill: "none",
    stroke: "#046079",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M16.41,3h.467A1.583,1.583,0,0,1,18.46,4.583V5.75",
    transform: "translate(-6.839 -3)",
    fill: "none",
    stroke: "#046079",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_821",
    "data-name": "Trac\\xE9 821",
    d: "M-3.293,0H4.193",
    transform: "translate(5.405)",
    fill: "none",
    stroke: "#046079",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M3,5.3V4.583A1.583,1.583,0,0,1,4.583,3h.792",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#046079",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_43",
    "data-name": "Ligne 43",
    y1: 9,
    transform: "translate(0 1.884)",
    fill: "none",
    stroke: "#046079",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M5.945,18.375H4.583A1.583,1.583,0,0,1,3,16.792V16",
    transform: "translate(-3 -5.708)",
    fill: "none",
    stroke: "#046079",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.6ca4c0d902305c2338018024a7e8beee.svg";
export { ForwardRef as ReactComponent };